var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { createReducer } from "typesafe-actions";
import "../epics/index.js";
import { resetUpdateResult } from "../epics/actions.js";
import { updateIsolationGroupEpicReducer } from "../epics/epics.js";
const defaultReducerState = {
  updateResult: getDefaultAsyncWrapperObj()
};
const actionsReducer = createReducer(defaultReducerState).handleAction(resetUpdateResult, (state) => __spreadProps(__spreadValues({}, state), {
  updateResult: getDefaultAsyncWrapperObj()
}));
const reducer = (state = defaultReducerState, action) => {
  state = updateIsolationGroupEpicReducer.reduxChange(state, action);
  state = actionsReducer(state, action);
  return state;
};
export {
  reducer as default,
  defaultReducerState,
  reducer
};
//# sourceMappingURL=ducks.js.map
